import { React, useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from "../../Utils/axiosConfig";
import { useGoogleLogin } from "@react-oauth/google";
import { RecoveryContext } from "../../App";

import "./Signup.css";

import { TogglePasswordLogin } from "./TogglePassword";
import ToggleTick from "./ToggleTick";

import logo from "../Assets/Logo.svg";
import google from "../Assets/Google.svg";
import gamereview from "../Assets/Game-review.svg";
import ai from "../Assets/AI.svg";
import puzzles from "../Assets/Puzzles.svg";
import book from "../Assets/Book.svg";
import visualisation from "../Assets/Visualisation.svg";

export function Login() {
  const [usernameOrEmail, setUsernameOrEmail] = useState("");
  const [password, setPassword] = useState();
  const [visiblePassword, setVisiblePassword] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const { setUsername } = useContext(RecoveryContext);
  const login = useGoogleLogin({
    onSuccess: (tokenResponse) => console.log(tokenResponse),
  });

  const navigate = useNavigate();

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let error = "";

    if (usernameOrEmail.length < 1) {
      error = "Username cannot be empty.";
    } else {
      if (usernameOrEmail.includes("@")) {
        if (!validateEmail(usernameOrEmail)) {
          error = "Invalid email format.";
        }
      }
    }
    if (error) {
      setErrorMessage(error);
    }
    axios
      .post("/login", {
        username: usernameOrEmail,
        email: usernameOrEmail,
        password,
      })
      .then((result) => {
        if (result.data.success) {
          const { username, token } = result.data;

          setUsername(username);

          if (rememberMe) {
            localStorage.setItem("username", username);
            localStorage.setItem("token", token);
          } else {
            sessionStorage.setItem("username", username);
            sessionStorage.setItem("token", token);

            localStorage.removeItem("username");
            localStorage.removeItem("token");
          }

          console.log("Login Success");
          navigate("/home");
        } else {
          setErrorMessage(result.data.message || "Login failed");
        }
      })
      .catch((err) => {
        console.error("Login error:", err);
        setErrorMessage("Login failed. Please try again.");
      });
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage("");
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [errorMessage]);

  useEffect(() => {
    const savedUser = localStorage.getItem("username");
    if (savedUser) {
      setUsernameOrEmail(savedUser);
    }
  }, []);

  useEffect(() => {
    const savedUser = localStorage.getItem("username");
    if (savedUser) {
      setUsernameOrEmail(savedUser);
    }

    const token =
      localStorage.getItem("token") || sessionStorage.getItem("token");

    if (token) {
      axios
        .get("/verify-token")
        .then((response) => {
          if (response.status === 200) {
            if (response.data.user && response.data.user.username) {
              setUsername(response.data.user.username);
            }
            navigate("/home");
          }
        })
        .catch((err) => {
          console.log(
            "Saved token is invalid or expired. Staying on Login page."
          );
          localStorage.removeItem("token");
          sessionStorage.removeItem("token");
        });
    }
  }, [navigate, setUsername]);

  return (
    <div className="container login-mobile-layout">
      <header className="header">
        <img className="logo-image" src={logo} alt="logo" />
        <div className="logo-text">
          <span className="C-logo">C</span>
          <span className="hezzle-logo">
            he<span className="Z-1">Z</span>
            <span className="Z-2">Z</span>le
          </span>
        </div>
        <Link to="/signup" className="login-button">
          Sign Up
        </Link>
      </header>
      <div className="gradient-line"></div>

      <div className="left-half">
        <img className="left-image" src={logo} alt="logo" />
        <div className="features">
          <ul>
            <li>
              <img src={gamereview} className="gamereview-svg" alt="" />
              Enhance your game analysis!
            </li>
            <br />
            <li>
              <img src={ai} className="ai-svg" alt="" />
              Get AI-assisted move breakdown.
            </li>
            <br />
            <li>
              <img src={puzzles} className="puzzles-svg" alt="" />
              Exclusive puzzles from your games!
            </li>
            <br />
            <li>
              <img src={book} className="book-svg" alt="" />
              Master your openings and middle game.
            </li>
            <br />
            <li>
              <img src={visualisation} className="visualisation-svg" alt="" />
              Level up your visualization skills!
            </li>
            <br />
          </ul>
        </div>
      </div>

      <div className="signup-form">
        <div className="line"></div>
        <h2 className="welcome">Welcome back!</h2>
        <form className="form" onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Username or email"
            className="username"
            value={usernameOrEmail}
            onChange={(e) =>
              setUsernameOrEmail(e.target.value.replace(/\s/g, ""))
            }
            onKeyDown={(e) => {
              if (e.key === "Enter") handleSubmit(e);
            }}
          />
          <div className="password-wrapper">
            <input
              type={visiblePassword ? "text" : "password"}
              placeholder="Password"
              className="password-login"
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleSubmit(e);
              }}
            />
            <TogglePasswordLogin onToggle={setVisiblePassword} />
          </div>
          <ToggleTick onToggle={setRememberMe} />
          <button type="submit" className="create-account-button">
            Log in
          </button>
        </form>
        <div className="or-and-line">
          <div className="orline1"></div>
          <br />
          <div className="or">or</div>
          <div className="orline2"></div>
        </div>
        <button className="google-signup-button" onClick={() => login()}>
          <img src={google} alt="Google Logo" />
          Sign in with Google
        </button>
        <div>
          {errorMessage && <p className="error-message">{errorMessage}</p>}{" "}
        </div>
      </div>
    </div>
  );
}
